// extracted by mini-css-extract-plugin
module.exports = {"header":"header_header__L5G5U","burgerBtn":"header_burgerBtn__7_EBY","links":"header_links__BVnOD","actions":"header_actions__50NOX","headerBtn":"header_headerBtn__pUlcb"};